import * as defaultImport from "@splunk/visualizations/LinkGraph";
export * from "@splunk/visualizations/LinkGraph";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
